import { Router } from '@okapi/router-react';
import React from 'react';
import { StoreContext } from 'storeon/react';
import { Baseline } from 'common/components';
import { ServicesMain } from 'landings/services-main';
import { RemoteProps } from './widgets-types';

export const ServicesMainRemote: React.FC<RemoteProps> = ({ router, store }) => (
  /* @ts-expect-error: Router typecheck error */
  <Router router={router}>
    <Baseline>
      <StoreContext.Provider value={store}>
        <ServicesMain />
      </StoreContext.Provider>
    </Baseline>
  </Router>
);
